import { DataTable } from "@/core/components/layout/data-table";
import { DashboardFilters } from "@/dashboard/types";
import { useEffect } from "react";
import { useDashboardRankingsUsers } from "../../hooks/use-dashboard-rankings-users";

interface DashboardRankingsUsersDataTableProps extends React.ComponentPropsWithoutRef<"div"> {
  filters: DashboardFilters;
  setTop3RankingData: (
    data: { position: number; name: string; value: number }[],
  ) => void;
  setIsLoading: (isLoading: boolean) => void;
}

export const DashboardRankingsUsersDataTable = ({
  filters,
  setTop3RankingData,
  setIsLoading,
  ...props
}: DashboardRankingsUsersDataTableProps) => {
  const { table, isLoading, top3RankingData } =
    useDashboardRankingsUsers(filters);

  useEffect(() => {
    setTop3RankingData(top3RankingData);
    setIsLoading(isLoading);
  }, [top3RankingData, isLoading]);

  return (
    <div {...props}>
      <DataTable table={table} isLoading={isLoading} withoutPagination={true} />
    </div>
  );
};
